export enum DigitalPayeeStatus {
    INITIATED = 'INITIATED',
    PAUSED = 'PAUSED',
    DISABLED = 'DISABLED',
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    AWAITING_VERIFICATION = 'AWAITING_VERIFICATION',
}
